import React from 'react';
import { ConfirmationProvider } from '@components/confirmation/Confirmation';
import { UserContext, UserType, useUserContext } from '@context/UserContext';
import { CompaniesContext, CompanyType } from '@context/CompaniesContext';

export interface AuthProviderData {
  userData: UserType;
  companiesData: CompanyType[];
}

export interface AppProviderProps {
  children: React.ReactNode | React.ReactNode[];
  authData: AuthProviderData;
  setSelectedCompany: (company?: CompanyType) => void;
  selectedCompany?: CompanyType;
}

const AppProvider = (props: AppProviderProps) => {
  const { children, authData, selectedCompany, setSelectedCompany } = props;
  const { userData, companiesData } = authData;
  const { setCurrentUser } = useUserContext();

  return (
    <UserContext.Provider value={{ user: userData, setCurrentUser }}>
      <CompaniesContext.Provider value={{ companies: companiesData, setSelectedCompany, selectedCompany }}>
        <ConfirmationProvider>{children}</ConfirmationProvider>
      </CompaniesContext.Provider>
    </UserContext.Provider>
  );
};

export default AppProvider;
